export default "__VITE_ASSET__C2p91RV9__"